
<template>
  <div class="about_us p_t">
    <TopHead title="俱乐部介绍"></TopHead>
    <!--顶部的富文本-->
    <div class="a_top">
      <div class="f_title">{{ydInfo.title}}</div>
      <div class="f_content" v-html="ydInfo.contentInfo"></div>
    </div>


  </div>
</template>

<script>
  export default {
    name: "AboutUs",
    data() {
      return {
        num: 0,
        content:[],
        cssList: [],
        opList: [],
        currentIndex: 0,
        index:0,
        synopsis:'',
        ydInfo:[],
        params:{
          pageIndex:1,
          pageSize:100,
          columnCode:'ryzz',
        },
        hzBanner:[],
        lnBanner:[{}],
        code:''
      }
    },
    created() {
      this.code = this.$route.query.code
      this.queryContentByCode(this.code);
    },
    methods: {
      //查询营地简介:ydjs
      queryContentByCode(code){
        this.$api.queryContentByCode(code).then(res => {
          if(code == 'jlbjs'){
            this.ydInfo = JSON.parse(JSON.stringify(res.data));
          }
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .a_ln{
    .al_items{
      width: calc((100% - 66px) / 3);
      height: 30px;
      margin-bottom:18px;
      img{
        width: 100%;
        height: 100%;
      }
      &:nth-child(3n - 1){
        margin: 0 33px 18px 33px;
      }
    }
    padding: 25px 16px 0;
    box-sizing: border-box;
    img{
      width: 100%;
    }
  }
  .carousel-containner{
    width: 260px;
    height: 100px;
    margin: 0 auto;
    .wrap{
      overflow: hidden;
      width: 100%;
      height: 100%;
      left: 0;
      margin-left: 0;
      position: relative;
      display: flex;
      align-items: center;
      flex-direction: column;
      .poster-item{
        transform: translateZ(0);
        width: 145px;
        height: 100%;
        font-size: .16rem;
        position: absolute;
        left: 0;
        top: 0;
        background: #fff;
        /*padding: 6px;*/
        box-sizing: border-box;
        transition: all 0.5s;
        .bkImg{
          width: 100%;
          height: 100%;
          overflow: hidden;
          img{
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 1;
          }
        }
        .bkName{
          width: 100%;
          margin: 19px 0 12px 0;
          text-align: center;
          overflow: hidden;
          span{
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
            font-size: 21px;
            font-weight: 800;
            color: #3E3E3E;
          }
        }
      }
    }
  }
  .s_change{
    width: 35px;
    height: 35px;
    top: 122px;
    img{
      width: 100%;
      height: 100%;
    }
    &.pre{
      left: 13px;
    }
    &.next{
      right: 13px;
    }
  }
  .f_title.sub{
    font-size: 10px;
    margin-bottom: 18px;
    font-weight: lighter;
    color: #FFFFFF;
    margin-top: -5px;
    &.s{
      font-size: 12px;
      margin-top: 3px;
    }
  }
  .f_title.p_r{
    opacity: 0.29;
    top: -10px;
    font-size: 24px;
    font-weight: lighter;
    &.b{
      opacity: 0.1;
    }
  }
  .s_out{
    box-sizing: border-box;
    padding: 20px 13px 10px;
    height: 236px;
    background: url("../assets/img/about_bg.png") no-repeat;
    background-size: 100% 100%;
  }
  .a_top{
    .f_content{
      ::v-deep img{
        max-width: 100%;
      }
      margin-top: 17px;
    }
    padding: 20px 12px 20px;
  }

</style>
